module.exports = __webpack_public_path__ + "img/Alien_symbol_2.3fc1f255.png";